import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AdminService } from "../api/AdminService";
import LoadingIndicator from "../components/LoadingIndicator";

// Layered on top of the existing ProtectedRoute (session-existence check
// only) — this additionally checks Cognito "Admin" group membership. A
// non-admin authenticated user sees a clear "not authorized" message
// instead of a blank page or a silent redirect loop.
const AdminGate = ({ children }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking"); // checking | authorized | denied

  useEffect(() => {
    const checkGroup = async () => {
      try {
        const groups = await AdminService.getAdminGroups();
        setStatus(groups.includes("Admin") ? "authorized" : "denied");
      } catch {
        navigate("/login");
      }
    };
    checkGroup();
  }, [navigate]);

  if (status === "checking") return <LoadingIndicator />;

  if (status === "denied") {
    return (
      <div className="flex h-screen w-full flex-col items-center justify-center gap-2 text-center">
        <h1 className="text-2xl font-bold">Not authorized</h1>
        <p className="text-base-content/70">
          Your account does not have admin access. Contact an existing admin
          if you believe this is a mistake.
        </p>
      </div>
    );
  }

  return children;
};

export default AdminGate;
